'use client';

import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import { CURRENCY_CONFIG, type SupportedCurrency } from '@/lib/env';

interface CurrencyPickerProps {
  value: SupportedCurrency;
  onChange: (currency: SupportedCurrency) => void;
  className?: string;
}

export function CurrencyPicker({ value, onChange, className }: CurrencyPickerProps) {
  const currentCurrency = CURRENCY_CONFIG.currencies[value];

  return (
    <Select
      value={value}
      onValueChange={(newValue) => onChange(newValue as SupportedCurrency)}
    >
      <SelectTrigger className={`flex items-center gap-2 h-9 px-3 ${className}`}>
        <Globe className="h-4 w-4" />
        <span className="font-medium">{currentCurrency.symbol} {value}</span>
      </SelectTrigger>
      <SelectContent align="end" className="min-w-[200px]">
        {Object.entries(CURRENCY_CONFIG.currencies).map(([code, info]) => (
          <SelectItem
            key={code}
            value={code}
            className="flex items-center justify-between cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <span className="font-medium text-lg">{info.symbol}</span>
              <div className="flex flex-col">
                <span className="font-medium">{code}</span>
                <span className="text-xs text-muted-foreground">{info.name}</span>
              </div>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}